import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getWfaSessionTopComponents } from 'src/apps/wfa/services/WfaDashboardService';
import { TWfaSessionTopComponentsResult } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { WFA_SESSION_TOP_COMPONENTS } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseWfaSessionComponentsQuery {
	sessionId: string;
}

export const useWfaTopSessionComponentsQuery = ({
	sessionId
}: IUseWfaSessionComponentsQuery): UseQueryResult<TWfaSessionTopComponentsResult> => {
	const componentsQuery = useQuery(
		[WFA_SESSION_TOP_COMPONENTS, sessionId],
		async (): Promise<TWfaSessionTopComponentsResult> =>
			getWfaSessionTopComponents({
				sessionId
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return componentsQuery;
};
